import { DateTime } from 'luxon';
import { Segment } from '../auto-tagger-service.types';

export const createSegment = {
  segmentId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  segmentName: 'test',
};

export let segments = {
  paging: {
    total: 9,
    count: 10,
    totalPages: 1,
    currentPage: 0,
  },
  segments: [
    {
      segmentId: '64c3b1c3a88db13d2542d2e8',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      merchantName: null,
      segmentName: '1st segment',
      segmentDescription: 'This is a test segment',
      segmentTag: 'SEG_1ST_SEGMENT',
      segmentIcon: '',
      visibleToCustomer: true,
      segmentRules: null,
      adminId: 'e8bf202c-3ed1-4c4d-b038-9055ad8711ef',
      adminEmail: 'darrel.r@aeturnum.com',
      startDate: '2023-07-31T18:30:00',
      createdDate: '2023-07-28T12:17:07',
      updateDate: '2023-07-28T12:17:07',
      lastProcessedDate: null,
      expiredStatus: true,
      displaySegmentStatus: 'INACTIVE',
      deletedStatus: false,
      segmentDistribution: 'AUTO',
      customerCount: 0,
    },
    {
      segmentId: '64c3b1dea88db13d2542d2ea',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      merchantName: null,
      segmentName: '3rd segment',
      segmentDescription: 'This is a test segment',
      segmentTag: 'SEG_3RD_SEGMENT',
      segmentIcon: '',
      visibleToCustomer: true,
      segmentRules: null,
      adminId: 'e8bf202c-3ed1-4c4d-b038-9055ad8711ef',
      adminEmail: 'darrel.r@aeturnum.com',
      startDate: '2023-07-31T18:30:00',
      createdDate: '2023-07-28T12:17:34',
      updateDate: '2023-07-28T12:17:34',
      lastProcessedDate: null,
      expiredStatus: false,
      displaySegmentStatus: 'ACTIVE',
      deletedStatus: false,
      segmentDistribution: 'AUTO',
      customerCount: 0,
    },
    {
      segmentId: '64c3b203a88db13d2542d2eb',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      merchantName: null,
      segmentName: '4rd segment',
      segmentDescription: 'This is a test segment',
      segmentTag: 'SEG_4RD_SEGMENT',
      segmentIcon: null,
      visibleToCustomer: true,
      segmentRules: null,
      adminId: 'e8bf202c-3ed1-4c4d-b038-9055ad8711ef',
      adminEmail: 'darrel.r@aeturnum.com',
      startDate: '2023-07-31T18:30:00',
      createdDate: '2023-07-28T12:18:11',
      updateDate: '2023-07-28T12:18:11',
      lastProcessedDate: null,
      expiredStatus: false,
      displaySegmentStatus: 'ACTIVE',
      deletedStatus: false,
      segmentDistribution: 'AUTO',
      customerCount: 0,
    },
    {
      segmentId: '64c3b27fa88db13d2542d2ec',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      merchantName: null,
      segmentName: '5th segment',
      segmentDescription: 'This is a test segment',
      segmentTag: 'SEG_5TH_SEGMENT',
      segmentIcon: null,
      visibleToCustomer: true,
      segmentRules: null,
      adminId: 'e8bf202c-3ed1-4c4d-b038-9055ad8711ef',
      adminEmail: 'darrel.r@aeturnum.com',
      startDate: '2023-07-31T18:30:00',
      createdDate: '2023-07-28T12:20:15',
      updateDate: '2023-08-10T12:20:15',
      lastProcessedDate: null,
      expiredStatus: false,
      displaySegmentStatus: 'ACTIVE',
      deletedStatus: false,
      segmentDistribution: 'AUTO',
      customerCount: 0,
    },
  ],
};

export let errorSegments = {
  paging: {
    total: 5,
    count: 10,
    totalPages: 1,
    currentPage: 0,
  },
  segments: [
    {
      segmentId: '64900000ecb78400e6c10c3d',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: null,
      merchantName: null,
      segmentName: 'Data Type Change 3',
      segmentDescription: 'This is a test segment',
      segmentTagName: 'SEG_DATA_TYPE_CHANGE_3',
      segmentIconType: null,
      segmentIcon: null,
      segmentIconFile: null,
      visibleToCustomer: false,
      segmentRules: null,
      startDate: null,
      endDate: null,
      expireType: null,
      createdDate: '2023-06-19T07:13:04',
      updateDate: '2023-06-19T07:13:04',
      lastProcessedDate: null,
      expiredStatus: false,
      deletedStatus: false,
      segmentDistribution: null,
      customerCount: 0,
      creatorEmail: 'test@gmail.com',
    },
    {
      segmentId: '64817026efc58e05eafe1d29',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: null,
      merchantName: null,
      segmentName: 'Test Custom Targeting 000',
      segmentDescription: 'This is a test segment',
      segmentTagName: 'SEG_TEST_CUSTOM_TARGETING_000',
      segmentIconType: null,
      segmentIcon: null,
      segmentIconFile: null,
      visibleToCustomer: false,
      segmentRules: null,
      startDate: null,
      endDate: null,
      expireType: null,
      createdDate: '2023-06-08T06:07:34',
      updateDate: '2023-06-08T06:07:34',
      lastProcessedDate: '2023-06-16T14:01:46',
      expiredStatus: false,
      deletedStatus: false,
      segmentDistribution: null,
      customerCount: 0,
      creatorEmail: 'test@gmail.com',
    },
    {
      segmentId: '648706e67cbb4511f193f416',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: null,
      merchantName: null,
      segmentName: 'Test Custom Targeting 0000008',
      segmentDescription: 'This is a test segment',
      segmentTagName: 'SEG_TEST_CUSTOM_TARGETING_0000008',
      segmentIconType: null,
      segmentIcon: null,
      segmentIconFile: null,
      visibleToCustomer: false,
      segmentRules: null,
      startDate: null,
      endDate: null,
      expireType: null,
      createdDate: '2023-06-12T11:52:06',
      updateDate: '2023-06-12T11:52:06',
      lastProcessedDate: '2023-06-16T14:02:59',
      expiredStatus: false,
      deletedStatus: false,
      segmentDistribution: null,
      customerCount: 0,
      creatorEmail: 'test@gmail.com',
    },
    {
      segmentId: '647f3c6b0e22f93343381a57',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: null,
      merchantName: null,
      segmentName: 'Test Custom Targeting 0024',
      segmentDescription: 'This is a test segment',
      segmentTagName: 'SEG_TEST_CUSTOM_TARGETING_0024',
      segmentIconType: null,
      segmentIcon: null,
      segmentIconFile: null,
      visibleToCustomer: false,
      segmentRules: null,
      startDate: null,
      endDate: null,
      expireType: null,
      createdDate: '2023-06-06T14:02:19',
      updateDate: '2023-06-06T14:02:19',
      lastProcessedDate: '2023-06-16T14:01:11',
      expiredStatus: false,
      deletedStatus: false,
      segmentDistribution: null,
      customerCount: 0,
      creatorEmail: 'test@gmail.com',
    },
    {
      segmentId: '6487039a7cbb4511f193eebe',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: null,
      merchantName: null,
      segmentName: 'Test Custom Targeting 0025',
      segmentDescription: 'This is a test segment',
      segmentTagName: 'SEG_TEST_CUSTOM_TARGETING_0025',
      segmentIconType: null,
      segmentIcon: null,
      segmentIconFile: null,
      visibleToCustomer: false,
      segmentRules: null,
      startDate: null,
      endDate: null,
      expireType: null,
      createdDate: '2023-06-12T11:38:02',
      updateDate: '2023-06-12T11:38:02',
      lastProcessedDate: '2023-06-16T14:02:51',
      expiredStatus: false,
      deletedStatus: false,
      segmentDistribution: null,
      customerCount: 0,
      creatorEmail: 'test@gmail.com',
    },
  ],
};

export let segment: Segment = {
  segmentId: 'test',
  clientId: 'test',
  merchantId: 'test',
  merchantName: 'test',
  createdDate: '2024-01-29T09:36:19.929Z',
  updateDate: '2024-01-29T09:36:19.929Z',
  lastProcessedDate: '2024-01-29T09:36:19.929Z',
  expiredStatus: false,
  displaySegmentStatus: 'ACTIVE',
  deletedStatus: false,
  segmentDistribution: 'AUTO',
  customerCount: 100,
  segmentName: 'pizza lover',
  segmentDescription: 'pizza lover description',
  segmentIcon:
    'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/default_tile_add025a701cc4c74ab66aebbb6b4f777.png',
  visibleToCustomer: true,
  adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
  adminEmail: 'bobm@incentivio.com',
  startDate: '2024-01-29T09:36:19.929Z',
  segmentRules: {
    ruleType: 'LOGIC',
    logicType: 'AND',
    childNodes: [
      {
        ruleType: 'LOGIC',
        logicType: 'AND',
        extendedAttributes: {
          groupType: 'SEGMENT_CUSTOMER',
        },
        childNodes: [
          {
            ruleType: 'EXPRESSION',
            operator: 'EQ',
            expressionValueNew: {
              attributeName: '0023',
              attributeValues: [3],
              dataType: 'NUMBER',
            },
          },
          {
            ruleType: 'EXPRESSION',
            operator: 'EQ',
            expressionValueNew: {
              attributeName: '14012023_TESTTAG',
              attributeValues: ['TRUE'],
              dataType: 'COLLECTION',
            },
          },
        ],
      },
      // {
      //   extendedAttributes: {
      //     groupType: 'SEGMENT_CUSTOM',
      //   },
      //   ruleType: 'LOGIC',
      //   logicType: 'AND',
      //   childNodes: [
      //     {
      //       ruleType: 'LOGIC',
      //       logicType: 'AND',
      //       childNodes: [
      //         {
      //           ruleType: 'EXPRESSION',
      //           operator: 'EQ',
      //           expressionValueNew: {
      //             attributeName: 'AVERAGE_BASKET_VALUE',
      //             attributeValues: [2],
      //             dataType: 'NUMBER',
      //           },
      //         },
      //         {
      //           ruleType: 'EXPRESSION',
      //           operator: 'EQ',
      //           expressionValueNew: {
      //             attributeName: 'AVERAGE_BASKET_VALUE',
      //             attributeValues: [4],
      //             dataType: 'NUMBER',
      //           },
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        extendedAttributes: {
          groupType: 'SEGMENT_ITEM',
        },
        ruleType: 'LOGIC',
        logicType: 'AND',
        childNodes: [
          {
            ruleType: 'EXPRESSION',
            operator: 'EQ',
            expressionValueNew: {
              productList: [
                {
                  id: '',
                  type: 'ITEM',
                  externalId: 'item1.1',
                  displayInfoTitlesList: [
                    'DI Item Title 1.1',
                    'DI Item Title 1.2',
                  ],
                },
              ],
              subCategory: 'LIFETIME',
              quantity: '1',
              noOfOrders: 0,
              noOfDays: 0,
              daysOfWeek: [],
              startTime: null,
              endTime: null,
            },
          },
          {
            ruleType: 'EXPRESSION',
            operator: 'GT',
            expressionValueNew: {
              productList: [
                {
                  id: '',
                  type: 'ITEM',
                  externalId: 'item1.1',
                  displayInfoTitlesList: [
                    'DI Item Title 1.1',
                    'DI Item Title 1.2',
                  ],
                },
              ],
              subCategory: 'NO_OF_ORDERS',
              quantity: '4',
              noOfOrders: 4,
              noOfDays: 0,
              daysOfWeek: ['MONDAY'],
              startTime: '00:30:00',
              endTime: '16:30:00',
            },
          },
        ],
      },
    ],
  },
  segmentTag: 'NONE',
  segmentType: 'NORMAL',
};

export let SegmentOneCustomerRule = {
  segmentName: 'pizza lover',
  segmentDescription: 'pizza lover description',
  segmentIcon:
    'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/default_tile_add025a701cc4c74ab66aebbb6b4f777.png',
  visibleToCustomer: true,
  languageCode: 'en-US',
  adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
  adminEmail: 'bobm@incentivio.com',
  startDate: '2024-01-29T09:36:19.929Z',
  timeZone: 'Asia/Colombo',
  segmentRules: {
    extendedAttributes: {
      groupType: 'SEGMENT_CUSTOMER',
    },
    ruleType: 'EXPRESSION',
    operator: 'EQ',
    expressionValueNew: {
      attributeName: '0023',
      attributeValues: [2],
      dataType: 'NUMBER',
    },
  },
  segmentTag: 'NONE',
  segmentType: 'NONE',
};

export let SegmentOneCustomRule = {
  segmentName: 'pizza lover',
  segmentDescription: 'pizza lover description',
  segmentIcon:
    'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/default_tile_add025a701cc4c74ab66aebbb6b4f777.png',
  visibleToCustomer: true,
  languageCode: 'en-US',
  adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
  adminEmail: 'bobm@incentivio.com',
  startDate: '2024-01-29T09:36:19.929Z',
  timeZone: 'Asia/Colombo',
  segmentRules: {
    extendedAttributes: {
      groupType: 'SEGMENT_CUSTOM',
    },
    operator: 'EQ',
    ruleType: 'EXPRESSION',
    expressionValueNew: {
      attributeName: 'ATTRITION_RISK',
      attributeValues: ['CHURNED'],
      dataType: 'COLLECTION',
    },
  },
  segmentTag: 'NONE',
  segmentType: 'NONE',
};

export let SegmentOneItemRule = {
  segmentName: 'pizza lover',
  segmentDescription: 'pizza lover description',
  segmentIcon:
    'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/default_tile_add025a701cc4c74ab66aebbb6b4f777.png',
  visibleToCustomer: true,
  languageCode: 'en-US',
  adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
  adminEmail: 'bobm@incentivio.com',
  startDate: '2024-01-29T09:36:19.929Z',
  timeZone: 'Asia/Colombo',
  segmentRules: {
    extendedAttributes: {
      groupType: 'SEGMENT_ITEM',
    },
    ruleType: 'EXPRESSION',
    operator: 'EQ',
    expressionValueNew: {
      productList: [],
      subCategory: 'LIFETIME',
      quantity: 3,
      noOfOrders: 0,
      noOfDays: 0,
      daysOfWeek: [],
      startTime: null,
      endTime: null,
    },
  },
};

export let SegmentTwoCustomerRules = {
  segmentName: 'pizza lover',
  segmentDescription: 'pizza lover description',
  segmentIcon:
    'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/default_tile_add025a701cc4c74ab66aebbb6b4f777.png',
  visibleToCustomer: true,
  languageCode: 'en-US',
  adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
  adminEmail: 'bobm@incentivio.com',
  startDate: '2024-01-29T09:36:19.929Z',
  timeZone: 'Asia/Colombo',
  segmentRules: {
    extendedAttributes: {
      groupType: 'SEGMENT_CUSTOMER',
    },
    ruleType: 'LOGIC',
    logicType: 'AND',
    childNodes: [
      {
        ruleType: 'EXPRESSION',
        operator: 'EQ',
        expressionValueNew: {
          attributeName: '14012023_TESTTAG',
          attributeValues: ['TRUE'],
          dataType: 'COLLECTION',
        },
      },
      {
        ruleType: 'EXPRESSION',
        operator: 'EQ',
        expressionValueNew: {
          attributeName: '1998_TAG',
          attributeValues: ['TRUE'],
          dataType: 'COLLECTION',
        },
      },
    ],
  },
};

export let SegmentTwoCustomRules = {
  segmentName: 'pizza lover',
  segmentDescription: 'pizza lover description',
  segmentIcon:
    'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/default_tile_add025a701cc4c74ab66aebbb6b4f777.png',
  visibleToCustomer: true,
  languageCode: 'en-US',
  adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
  adminEmail: 'bobm@incentivio.com',
  startDate: '2024-01-29T09:36:19.929Z',
  timeZone: 'Asia/Colombo',
  segmentRules: {
    extendedAttributes: {
      groupType: 'SEGMENT_CUSTOM',
    },
    ruleType: 'LOGIC',
    logicType: 'AND',
    childNodes: [
      {
        ruleType: 'LOGIC',
        logicType: 'AND',
        childNodes: [
          {
            ruleType: 'EXPRESSION',
            operator: 'EQ',
            expressionValueNew: {
              attributeName: 'AVERAGE_BASKET_VALUE',
              attributeValues: [2],
              dataType: 'NUMBER',
            },
          },
          {
            ruleType: 'EXPRESSION',
            operator: 'GT',
            expressionValueNew: {
              attributeName: 'AVERAGE_BASKET_VALUE',
              attributeValues: [0],
              dataType: 'NUMBER',
            },
          },
        ],
      },
      {
        ruleType: 'EXPRESSION',
        operator: 'EQ',
        expressionValueNew: {
          attributeName: 'AVERAGE_BASKET_VALUE_PER_MONTH',
          attributeValues: [2],
          dataType: 'NUMBER',
        },
      },
    ],
  },
};

export let segmentTwoItemRules = {
  segmentName: 'pizza lover',
  segmentDescription: 'pizza lover description',
  segmentIcon:
    'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/default_tile_add025a701cc4c74ab66aebbb6b4f777.png',
  visibleToCustomer: true,
  languageCode: 'en-US',
  adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
  adminEmail: 'bobm@incentivio.com',
  startDate: '2024-01-29T09:36:19.929Z',
  timeZone: 'Asia/Colombo',
  segmentRules: {
    extendedAttributes: {
      groupType: 'SEGMENT_ITEM',
    },
    ruleType: 'LOGIC',
    logicType: 'AND',
    childNodes: [
      {
        ruleType: 'EXPRESSION',
        operator: 'EQ',
        expressionValueNew: {
          productList: [],
          subCategory: 'LIFETIME',
          quantity: 3,
          noOfOrders: 0,
          noOfDays: 0,
          daysOfWeek: ['MONDAY', 'TUESDAY'],
          startTime: null,
          endTime: null,
        },
      },
      {
        ruleType: 'EXPRESSION',
        operator: 'EQ',
        expressionValueNew: {
          productList: [],
          subCategory: 'NO_OF_ORDERS',
          quantity: 1,
          noOfOrders: 3,
          noOfDays: 0,
          daysOfWeek: [],
          startTime: null,
          endTime: null,
        },
      },
    ],
  },
};

export let oneFromEachRule = {
  segmentName: 'pizza lover',
  segmentDescription: 'pizza lover description',
  visibleToCustomer: true,
  languageCode: 'en-US',
  adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
  adminEmail: 'bobm@incentivio.com',
  startDate: DateTime.now().toISODate(),
  timeZone: 'Asia/Colombo',
  segmentRules: {
    ruleType: 'LOGIC',
    logicType: 'AND',
    childNodes: [
      {
        ruleType: 'LOGIC',
        logicType: 'AND',
        childNodes: [
          {
            extendedAttributes: {
              groupType: 'SEGMENT_CUSTOMER',
            },
            ruleType: 'EXPRESSION',
            operator: 'EQ',
            expressionValueNew: {
              attributeName: '0023',
              attributeValues: [3],
              dataType: 'NUMBER',
            },
          },
          {
            extendedAttributes: {
              groupType: 'SEGMENT_CUSTOM',
            },
            operator: 'EQ',
            ruleType: 'EXPRESSION',
            expressionValueNew: {
              attributeName: 'AVERAGE_BASKET_VALUE',
              attributeValues: [2],
              dataType: 'NUMBER',
            },
          },
        ],
      },
      {
        extendedAttributes: {
          groupType: 'SEGMENT_ITEM',
        },
        ruleType: 'EXPRESSION',
        operator: 'EQ',
        expressionValueNew: {
          productList: [
            {
              id: '',
              type: 'ITEM',
              externalId: 'item1.1',
              displayInfoTitlesList: ['DI Item Title 1.1', 'DI Item Title 1.2'],
            },
          ],
          subCategory: 'LIFETIME',
          quantity: 3,
          noOfOrders: 0,
          noOfDays: 0,
          daysOfWeek: [],
          startTime: null,
          endTime: null,
        },
      },
    ],
  },
};

export let multipleCustomerCutomRules = {
  segmentName: 'pizza lover',
  segmentDescription: 'pizza lover description',
  visibleToCustomer: true,
  languageCode: 'en-US',
  adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
  adminEmail: 'bobm@incentivio.com',
  startDate: DateTime.now().toISODate(),
  timeZone: 'Asia/Colombo',
  segmentRules: {
    ruleType: 'LOGIC',
    logicType: 'AND',
    childNodes: [
      {
        extendedAttributes: {
          groupType: 'SEGMENT_CUSTOMER',
        },
        ruleType: 'LOGIC',
        logicType: 'AND',
        childNodes: [
          {
            ruleType: 'EXPRESSION',
            operator: 'EQ',
            expressionValueNew: {
              attributeName: '0023',
              attributeValues: [2],
              dataType: 'NUMBER',
            },
          },
          {
            ruleType: 'EXPRESSION',
            operator: 'EQ',
            expressionValueNew: {
              attributeName: '14012023_TESTTAG',
              attributeValues: ['TRUE'],
              dataType: 'COLLECTION',
            },
          },
        ],
      },
      {
        extendedAttributes: {
          groupType: 'SEGMENT_CUSTOM',
        },
        ruleType: 'LOGIC',
        logicType: 'AND',
        childNodes: [
          {
            ruleType: 'LOGIC',
            logicType: 'AND',
            childNodes: [
              {
                ruleType: 'EXPRESSION',
                operator: 'EQ',
                expressionValueNew: {
                  attributeName: 'AVERAGE_BASKET_VALUE',
                  attributeValues: [3],
                  dataType: 'NUMBER',
                },
              },
              {
                ruleType: 'EXPRESSION',
                operator: 'GT',
                expressionValueNew: {
                  attributeName: 'AVERAGE_BASKET_VALUE',
                  attributeValues: [2],
                  dataType: 'NUMBER',
                },
              },
            ],
          },
          {
            ruleType: 'EXPRESSION',
            operator: 'GT',
            expressionValueNew: {
              attributeName: 'PURCHASES_PER_MONTH',
              attributeValues: [3],
              dataType: 'NUMBER',
            },
          },
        ],
      },
    ],
  },
};

export let oneCustomerCustomRule = {
  segmentName: 'pizza lover',
  segmentDescription: 'pizza lover description',
  visibleToCustomer: true,
  languageCode: 'en-US',
  adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
  adminEmail: 'bobm@incentivio.com',
  startDate: DateTime.now().toISODate(),
  timeZone: 'Asia/Colombo',
  segmentRules: {
    ruleType: 'LOGIC',
    logicType: 'AND',
    childNodes: [
      {
        extendedAttributes: {
          groupType: 'SEGMENT_CUSTOMER',
        },
        ruleType: 'EXPRESSION',
        operator: 'EQ',
        expressionValueNew: {
          attributeName: '0023',
          attributeValues: [2],
          dataType: 'NUMBER',
        },
      },
      {
        extendedAttributes: {
          groupType: 'SEGMENT_CUSTOM',
        },
        operator: 'EQ',
        ruleType: 'EXPRESSION',
        expressionValueNew: {
          attributeName: 'ATTRITION_RISK',
          attributeValues: ['CHURNED'],
          dataType: 'COLLECTION',
        },
      },
    ],
  },
};
